module.exports = __webpack_public_path__ + "static/img/login-back.0d936a6f.png";